import type { SVGProps } from "react";

export const MFADuoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1334px"
    height="1334px"
    viewBox="0 0 1334 1334"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <path
      d="M1333.3333,666.659983 C1333.3333,298.465326 1034.85864,0 666.67865,0 C298.469326,0 0,298.465326 0,666.659983 C0,1034.85331 298.469326,1333.3333 666.67865,1333.3333 C1034.85864,1333.3333 1333.3333,1034.85331 1333.3333,666.659983"
      id="path14"
      fill="#59B734"
    ></path>
    <path
      d="M730.593458,301 L377,301 L377,644.943904 L1083.53538,644.943904 C1072.98291,453.125198 918.994786,301 730.593458,301"
      id="path16"
      fill="#FFFFFF"
    ></path>
    <path
      d="M730.593458,301 L377,301 L377,644.943904 L1083.53538,644.943904 C1072.98291,453.125198 918.994786,301 730.593458,301"
      id="path18"
      fill="#E6F3D8"
    ></path>
    <path
      d="M730.593458,1031.94712 L377,1031.94712 L377,688 L1083.53538,688 C1072.98291,879.751124 918.994786,1031.94712 730.593458,1031.94712"
      id="path20"
      fill="#FFFFFF"
    ></path>
  </svg>
);
